"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncCommand = exports.ValidateWithJsonSchema = exports.JsonSchemaValidationError = exports.Switch = exports.Not = exports.Noop = exports.If = exports.GetUnixEpoch = exports.GetCtime = void 0;
const lib_errors_1 = require("@orbits/lib-errors");
const ajv_1 = __importDefault(require("ajv"));
const moment_1 = __importDefault(require("moment"));
class GetCtime {
    execute({ time }) {
        return moment_1.default(time).toISOString();
    }
}
exports.GetCtime = GetCtime;
class GetUnixEpoch {
    execute(time) {
        return moment_1.default(time).unix();
    }
}
exports.GetUnixEpoch = GetUnixEpoch;
class If {
    constructor(conditionCommand, ifCommand, elseCommand = new Noop()) {
        this.conditionCommand = conditionCommand;
        this.ifCommand = ifCommand;
        this.elseCommand = elseCommand;
    }
    async execute(input) {
        let result;
        if (await this.conditionCommand.execute(input)) {
            result = this.ifCommand.execute(input);
        }
        else {
            result = this.elseCommand.execute(input);
        }
        return result;
    }
}
exports.If = If;
class Noop {
    async execute() { }
}
exports.Noop = Noop;
class Not {
    constructor(command) {
        this.command = command;
    }
    async execute(input) {
        return !(await this.command.execute(input));
    }
}
exports.Not = Not;
class Switch {
    constructor(getKey, commands) {
        this.getKey = getKey;
        this.commands = commands;
    }
    async execute(input) {
        const key = await this.getKey.execute(input);
        const command = this.commands.get(key);
        if (!command) {
            throw new lib_errors_1.OrbitsError('Cannot find a command for key "%s".', key);
        }
        return command.execute(input);
    }
}
exports.Switch = Switch;
class JsonSchemaValidationError extends lib_errors_1.ValidationError {
    constructor(data, schema, errors, message, ...messageArgs) {
        super({
            info: {
                data,
                schema,
                errors,
            },
        }, message ?? JsonSchemaValidationError.DEFAULT_MESSAGE, messageArgs);
        // Work around https://github.com/microsoft/TypeScript/issues/13965
        Object.setPrototypeOf(this, JsonSchemaValidationError.prototype);
    }
}
exports.JsonSchemaValidationError = JsonSchemaValidationError;
JsonSchemaValidationError.DEFAULT_MESSAGE = "JSON-Schema validation failed.";
class ValidateWithJsonSchema {
    constructor(schema) {
        this.schema = schema;
        this.isValid = this.createValidator(schema);
    }
    execute(input) {
        if (!this.isValid(input)) {
            throw new JsonSchemaValidationError(input, this.schema, this.isValid.errors);
        }
    }
    createValidator(schema) {
        const ajv2 = new ajv_1.default({ schemaId: "id" });
        ajv2.addMetaSchema(require("ajv/lib/refs/json-schema-draft-04.json"));
        return ajv2.compile(schema);
    }
}
exports.ValidateWithJsonSchema = ValidateWithJsonSchema;
class AsyncCommand {
    constructor(command) {
        this.command = command;
    }
    async execute(input) {
        return this.command.execute(input);
    }
}
exports.AsyncCommand = AsyncCommand;
//# sourceMappingURL=index.js.map